// components/layout/Header.tsx
"use client";

import { usePathname } from "next/navigation";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "./ThemeToggle";
import { NotificationDropdown } from "./NotificationDropdown";
import { UserDropdown } from "./UserDropdown";
import { SearchCommand } from "./SearchCommand";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

const PAGE_TITLES: Record<string, string> = {
  "/": "داشبورد",
  "/products": "محصولات",
  "/orders": "سفارشات",
  "/users": "کاربران",
  "/coupons": "کدهای تخفیف",
  "/support": "پشتیبانی",
  "/pos": "صندوق‌ها",
  "/settings": "تنظیمات",
};

interface HeaderProps {
  onOpenSidebar: () => void;
}

export function Header({ onOpenSidebar }: HeaderProps) {
  const pathname = usePathname();
  const title = PAGE_TITLES[pathname] || "پنل مدیریت";

  return (
    // گرادیان و سایه مطابق با استایل hero-banner به همراه حفظ کلاس dark برای آیکون‌ها
    <header className="dark h-16 bg-[linear-gradient(120deg,#06371f,#0b6b3a_55%,#128a4b)] flex items-center justify-between px-4 lg:px-6 sticky top-0 z-30 shadow-[0_14px_34px_rgba(8,60,32,0.22)] border-none text-white transition-colors">
      <div className="flex items-center gap-2 lg:gap-4 min-w-0">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden shrink-0 text-[#c8e3d1] hover:text-white hover:bg-white/10"
          onClick={onOpenSidebar}
          aria-label="باز کردن منو"
        >
          <Menu className="h-5 w-5" />
        </Button>

        <Breadcrumb className="hidden sm:block">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/" className="text-[#c8e3d1] hover:text-white">
                خانه
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-[#c8e3d1]" />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-bold text-white">{title}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <h2 className="sm:hidden text-base font-bold truncate text-white">{title}</h2>
      </div>

      <div className="flex items-center gap-1.5 lg:gap-3 shrink-0">
        <SearchCommand />
        {/* جداکننده عمودی */}
        <div className="w-px h-5 bg-white/20 mx-1 hidden sm:block"></div>
        <NotificationDropdown />
        <ThemeToggle />
        <UserDropdown />
      </div>
    </header>
  );
}